import { useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types/auto-generator-for-view-model";

type Props = {
	checkInStart: ForNodeType<string | null | undefined>;
	checkInEnd: ForNodeType<string | null | undefined>;
	checkOut: ForNodeType<string | null | undefined>;

	onSetViewModel: <K extends "checkInStart" | "checkInEnd" | "checkOut">(
		values: { key: K; value: ForNodeType<string | null | undefined> }[],
	) => void;
};

export const useCheckInAndCheckOut = ({
	checkInStart: _checkInStart,
	checkInEnd: _checkInEnd,
	checkOut: _checkOut,
	onSetViewModel,
}: Props) => {
	const onSetCheckInStart: (value: string) => void = useCallback(
		(value) => {
			const checkInStart = {
				..._checkInStart,
				value,
			};

			onSetViewModel([{ key: "checkInStart", value: checkInStart }]);
		},
		[_checkInStart, onSetViewModel],
	);

	const onSetCheckInEnd: (value: string) => void = useCallback(
		(value) => {
			const checkInEnd = {
				..._checkInEnd,
				value,
			};

			onSetViewModel([{ key: "checkInEnd", value: checkInEnd }]);
		},
		[_checkInEnd, onSetViewModel],
	);

	const onSetCheckOut: (value: string) => void = useCallback(
		(value) => {
			const checkOut = {
				..._checkOut,
				value,
			};

			onSetViewModel([{ key: "checkOut", value: checkOut }]);
		},
		[_checkOut, onSetViewModel],
	);

	return {
		checkInStart: _checkInStart,
		onSetCheckInStart,

		checkInEnd: _checkInEnd,
		onSetCheckInEnd,

		checkOut: _checkOut,
		onSetCheckOut,
	};
};
